// This is a purely presentational component, use with DownloadButtonWrapper.
import React from 'react';
import styled from 'astroturf/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowToBottom } from '@fortawesome/pro-solid-svg-icons';

const DownloadButton = styled.div`
  cursor: pointer;
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 13px;
  color: #777777;
  margin-right: 8px;
  margin-left: -8px;
  padding: 5px 9px;
  align-items: center;

  &:hover {
    background: #ffffff;
    border-radius: 4px;
    color: #0849b8;
  }

  &:active {
    background: #dfeafd;
    border-radius: 4px;
  }
`;

type Props = {
  styleAsDownloaded: boolean;
  onDownloadClick: React.MouseEventHandler;
  showWhiteBackground: boolean;
};

const DownloadButtonSearchRedesign = ({
  styleAsDownloaded,
  onDownloadClick,
}: Props) => (
  <DownloadButton onClick={onDownloadClick}>
    <FontAwesomeIcon
      style={{ marginRight: 6, fontSize: 12 }}
      icon={faArrowToBottom}
    />
    Download{styleAsDownloaded && 'ed'}
  </DownloadButton>
);

export default DownloadButtonSearchRedesign;
